interface NavigatorUABrandVersion {
    brand: string;
    version: string;
}

interface NavigatorUAData {
    brands: NavigatorUABrandVersion[];
    mobile: boolean;
    platform: string;
}

/**
 * Currently only Chromium based browsers support User Agent Client Hints
 * So it is good enough to assume it is a Chromium-based browsers when it
 * supports UserAgentData
 */
export const isChromiumWindows = () => {
    if ('userAgentData' in navigator) {
        const UA = navigator.userAgentData as NavigatorUAData;
        return UA.platform.includes('Windows');
    }
    return false;
};
